import Input from 'component/atom/forms/input/input/Input';
import Select from 'component/atom/forms/select/select/Select';
import Toggle from 'component/atom/forms/toggle/Toggle';
import React from 'react';
import styles from './fields.module.scss';
import { useFormikContext } from 'formik';
import OptionsSelector from 'component/atom/forms/options-selector/OptionsSelector';
const RadioButtonField = ({ index, field }) => {
  const formik = useFormikContext();
  return (
    <div
      className={`${styles['field']} ${styles['text']} ${styles['radio-button']}  `}
    >
      <Input
        label="Input Label"
        placeholder="Enter Label"
        name={`formDetails[${index}].fieldLabel`}
        value={field.fieldLabel}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.formDetails?.[index]?.fieldLabel &&
          formik.errors.formDetails?.[index]?.fieldLabel
        }
        touched={
          formik.touched.formDetails?.[index]?.fieldLabel &&
          formik.errors.formDetails?.[index]?.fieldLabel
        }
      />
      <OptionsSelector
        label="Options"
        placeholder="Manage Options"
        name={`formDetails[${index}].formsDetailOptions`}
        value={field.formsDetailOptions}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.formDetails?.[index]?.formsDetailOptions &&
          formik.errors.formDetails?.[index]?.formsDetailOptions
        }
        touched={
          formik.touched.formDetails?.[index]?.formsDetailOptions &&
          formik.errors.formDetails?.[index]?.formsDetailOptions
        }
        maxOptions={4}
      />

      <div className={styles['fieldContainer']}>
        <Toggle
          label="Required"
          left={true}
          name={`formDetails[${index}].isMandatory`}
          value={field.isMandatory}
          onChange={(e) =>
            formik.setFieldValue(
              `formDetails[${index}].isMandatory`,
              e.target.value
            )
          }
          style={{ flexDirection: 'column' }}
        />
      </div>
    </div>
  );
};

export default RadioButtonField;
